import { streamBedrock, streamSimpleBedrock } from "./providers/amazon-bedrock.js";

// Bundled CLI entry points load this module separately and need the shared log sink.
export { setLogSink } from "./log.js";

export const bedrockProviderModule = {
	streamBedrock,
	streamSimpleBedrock,
};
